import { MenuGroup } from "@portal/BaseComponents/Menu/type";
import { GenericRadioOptions } from "@portal/BaseComponents/Radio/types";
import { DisputeViews } from "@portal/types/entities/dispute";
import { DefaultDisputeKeys } from "./type";

const disputeFilterGroup: MenuGroup[] = [
  {
    type: "group",
    label: "Dispute",
    key: "Dispute",
    children: [],
  },
];

export const disputeFilterGroups = [
  ...disputeFilterGroup,
];

export const defaultDisputeKeys: DefaultDisputeKeys[] = [
  "date_range",
  "dispute_type_ids",
  "from_amount",
  "from_date",
];
export const disputeViewOptions: GenericRadioOptions<DisputeViews> = [
  {
    label: "All",
    value: "ALL",
  },
  { label: "Open", value: "OPEN" },
  {
    label: "Closed",
    value: "CLOSED",
  },
  {
    label: "Pending on my side",
    value: "WAITING_ON_CUSTOMER",
  },
];

export const disputeStatusOptions = [
  { label: "Open", value: "OPEN" },
  {
    label: "Closed",
    value: "CLOSED",
  },
  {
    label: "Pending on my side",
    value: "WAITING_ON_CUSTOMER",
  },
];
